import React, { useState } from 'react';
import patientApi from '../api/patient.api';

const DeleteAccountModal = ({ show, onClose, onDeleted }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    setLoading(true);
    setError(null);

    try {
      await patientApi.deleteMyAccount();
      onDeleted();
    } catch (err) {
      console.error('Failed to delete account:', err);
      setError(err.response?.data?.message || 'Failed to delete account. Please try again.');
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: '#dc3545', color: 'white' }}>
            <h5 className="modal-title">Изтриване на акаунт</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
              disabled={loading}
            />
          </div>
          <div className="modal-body">
            <div className="text-center mb-3">
              <i className="fas fa-exclamation-triangle" style={{ fontSize: '48px', color: '#dc3545' }}></i>
            </div>
            <h5 className="text-center mb-3">Сигурни ли сте?</h5>
            <p className="text-muted text-center">
              Това действие е необратимо. Вашият акаунт ще бъде деактивиран и няма да можете да влезете отново.
            </p>
            <p className="text-muted text-center small">
              Медицинските ви записи ще бъдат запазени съгласно законовите изисквания.
            </p>
            {error && (
              <div className="alert alert-danger mt-3" role="alert">
                {error}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Отказ
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleDelete}
              disabled={loading}
            >
              {loading ? 'Изтриване...' : 'Изтрий акаунта'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountModal;
